export const PRIORITIES = ['A', 'B', 'C'] as const;
export type Priority = (typeof PRIORITIES)[number];

export const ROLES = ['owner', 'admin', 'member'] as const;
export type Role = (typeof ROLES)[number];

export const FIELD_TYPES = ['text', 'number', 'date', 'select', 'url', 'email'] as const;
export type FieldType = (typeof FIELD_TYPES)[number];

export const STALE_DAYS = 7;

// Stage definitions seeded for new orgs.
// `probability` powers weighted forecasts; `slaDays` powers Kanban "stuck" coloring.
export const DEFAULT_STAGES = [
  { name: 'New',            order: 0, color: '#6366f1', isWon: false, isLost: false, probability: 5,   slaDays: 7  },
  { name: 'Qualified',      order: 1, color: '#3b82f6', isWon: false, isLost: false, probability: 15,  slaDays: 7  },
  { name: 'Demo Scheduled', order: 2, color: '#8b5cf6', isWon: false, isLost: false, probability: 25,  slaDays: 14 },
  { name: 'Demo Done',      order: 3, color: '#a855f7', isWon: false, isLost: false, probability: 40,  slaDays: 14 },
  { name: 'Proposal Sent',  order: 4, color: '#f59e0b', isWon: false, isLost: false, probability: 60,  slaDays: 14 },
  { name: 'Negotiation',    order: 5, color: '#f97316', isWon: false, isLost: false, probability: 80,  slaDays: 21 },
  { name: 'Closed Won',     order: 6, color: '#22c55e', isWon: true,  isLost: false, probability: 100, slaDays: null as number | null },
  { name: 'Closed Lost',    order: 7, color: '#ef4444', isWon: false, isLost: true,  probability: 0,   slaDays: null as number | null },
] as const;

export const DEFAULT_ACTIVITY_TYPES = [
  { name: 'Call',     template: 'Spoke with {contact}. Topics covered:\n- \n- \n\nNext step: ' },
  { name: 'Meeting',  template: 'Meeting with {contact} on {date}.\nAttendees: \n\nNotes:\n- \n\nNext step: ' },
  { name: 'Email',    template: 'Sent email re: ' },
  { name: 'WhatsApp', template: '' },
  { name: 'Demo',     template: 'Demo with {contact} on {date}.\nReactions:\n- \n\nObjections:\n- \n\nNext step: ' },
  { name: 'Note',     template: '' },
] as const;

export const DEFAULT_CUSTOM_FIELDS = [
  {
    key: 'industry',
    label: 'Industry',
    type: 'select' as const,
    options: [
      'Restaurant',
      'Retail',
      'Manufacturing',
      'Services',
      'Healthcare',
      'Tech',
      'Logistics',
      'Other',
    ],
    showInList: true,
    order: 0,
  },
];

export const DEFAULT_WON_REASONS = [
  'Best fit',
  'Price',
  'Existing relationship',
  'Feature differentiator',
  'Reference customer',
] as const;

export const DEFAULT_LOST_REASONS = [
  'Price too high',
  'Lost to competitor',
  'No budget',
  'No decision',
  'Bad timing',
  'Wrong fit',
] as const;
